var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"datatable-pagination"},[_c('div',{class:_vm.prevClasses,on:{"click":_vm.prev}},[_c('i',{staticClass:"icon-previous"})]),_c('div',{class:_vm.nextClasses,on:{"click":_vm.next}},[_c('i',{staticClass:"icon-next"})])])}
var staticRenderFns = []

export { render, staticRenderFns }